import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';
import { AnimatePresence, motion } from 'framer-motion';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.mp4';

import { useBroadcast } from './hooks/useBroadcast';
import { Result } from './components/Result/Result';
import { Winner } from './components/Winners/Winner';
import QuestionAndAdvt from './components/QuestionAndAdvt/QuestionAndAdvt';
import Question from './components/Question/Question';

import posterWinners from './assets/images/posterWinners.png';

function App() {
  const { voteState, currentState } = useVote();
  const { winnerMessages: winners } = useBroadcast();

  const { bgVideo, bgPoster, questionFontSize, winnerFontSize } =
    useGetParams();

  let correctVar = voteState?.vars?.find((el) => el.correct);

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            style={{ height: '100%', width: '100%' }}
            key="S1"
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.66 }}>
            <Question
              question={voteState?.title}
              questionFontSize={questionFontSize}
              bgVideo={bgVideo}
              bgPoster={bgPoster}
            />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            style={{ height: '100%', width: '100%' }}
            key="S2"
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.66 }}>
            <QuestionAndAdvt
              question={voteState?.title}
              questionFontSize={questionFontSize}
              bgVideo={bgVideo}
              bgPoster={bgPoster}
            />
          </motion.div>
        )}

        {currentState === 'S3' && (
          <motion.div
            style={{ height: '100%', width: '100%' }}
            key="S3"
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.66 }}>
            <Result
              vars={voteState?.vars}
              bgVideo={bgVideo}
              bgPoster={bgPoster}
            />
          </motion.div>
        )}

        {currentState === 'S4' && (
          <motion.div
            style={{ height: '100%', width: '100%' }}
            key="S4"
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.66 }}>
            <Winner
              winnerFontSize={winnerFontSize}
              winners={winners}
              bgVideo={bgVideo}
              bgPoster={bgPoster}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={bgVideo === '1' ? posterDefault : bgPoster}>
        <source
          src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
          type="video/mp4"></source>
      </video>

      <div id="img-loader" />

      {correctVar?.varImgUrl && (
        <img
          src={correctVar?.varImgUrl}
          alt="correctVar"
          style={{ display: 'none' }}
        />
      )}
      <img
        src={posterWinners}
        alt="posterWinners"
        style={{ display: 'none' }}
      />
    </div>
  );
}

export default App;
